import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FamiliaService } from './familia-service/familia.service';

@Component({
  selector: 'app-familia',
  templateUrl: './familia.component.html',
  styleUrls: ['./familia.component.css']
})
export class FamiliaComponent implements OnInit {

  carregando = true;
  familias: any[] = [];
  display: boolean = false;
  nomeNovaFamilia: string = '';
  
  // Variáveis para modal de confirmação de exclusão
  displayConfirmarExclusao: boolean = false;
  familiaParaExcluir: any = null;
  
  // Variáveis para modal de vínculos
  displayVinculos: boolean = false;
  carregandoVinculos: boolean = false;
  familiaSelecionada: any = null;
  elementosDisponiveis: any[] = [];
  elementosVinculados: any[] = [];
  elementosDisponiveisFiltrados: any[] = [];
  elementosVinculadosFiltrados: any[] = [];
  alteracoesVinculos: boolean = false;
  termoPesquisaDisponiveis: string = '';
  termoPesquisaVinculados: string = '';
  

  constructor(
    private serviceFamilia: FamiliaService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.carregando = true;
    this.carregarFamilias();
  }

  showDialog() {
    this.display = true;
  }

  hideDialog() {
    this.display = false;
  }

  carregarFamilias() {
    this.carregando = true;
    this.familias = [];
    
    this.serviceFamilia.getFamilias()
      .then((response: any) => {
        
        // A API retorna diretamente o array, não dentro de response.data
        let dadosFamilias = response;
        
        // Se a resposta estiver dentro de response.data, usar response.data
        if (response && response.data && Array.isArray(response.data)) {
          dadosFamilias = response.data;
        }
        
        if (dadosFamilias && Array.isArray(dadosFamilias)) {
          // Mapear os dados da API para o formato interno
          this.familias = dadosFamilias.map((familia: any) => ({
            id: familia.idPadraoVeiculos,
            nome: familia.descProduto,
            vinculos: familia.countVinculados
          }));
          
        }
        this.carregando = false;
      })
      .catch((error: any) => {
        this.carregando = false;
        console.error('Erro ao carregar famílias:', error); // Debug
        this.tratarErro(
          this.translate.instant('parametros.familia.erroCarregarFamilias'),
          this.translate.instant('parametros.familia.erro'),
          error
        );
      });
  }


  adicionarFamilia(nomeFamilia: string) {
    if (!nomeFamilia || nomeFamilia.trim() === '') {
      this.exibirErro(this.translate.instant('parametros.familia.nomeObrigatorio'), this.translate.instant('parametros.familia.erro'));
      return;
    }

    // Verificar se já existe uma família com este nome
    const familiaExistente = this.familias.find(f => 
      f.nome.toLowerCase() === nomeFamilia.toLowerCase()
    );

    if (familiaExistente) {
      this.exibirErro(this.translate.instant('parametros.familia.familiaJaExiste'), this.translate.instant('parametros.familia.erro'));
      return;
    }

    // Chamada para o backend para criar a família
    this.serviceFamilia.adicionarFamilia(nomeFamilia.trim())
      .then((response: any) => {
        
        this.exibirSucesso(
          this.translate.instant('parametros.familia.familiaAdicionada'), 
          this.translate.instant('parametros.familia.sucesso')
        );
        this.limparFormulario();
        this.hideDialog();
        
        // Recarregar a lista de famílias após adicionar
        this.carregarFamilias();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.familia.erroAdicionarFamilia'),
          this.translate.instant('parametros.familia.erro'),
          error
        );
      });
  }

  private limparFormulario() {
    this.nomeNovaFamilia = '';
  }

  removerFamilia(idFamilia: number) {
    const index = this.familias.findIndex(f => f.id === idFamilia);
    if (index > -1) {
      const familiaRemovida = this.familias[index];
      
      // Verificar se há vínculos ativos
      if (familiaRemovida.vinculos > 0) {
        const mensagem = this.translate.instant('parametros.familia.naoPodeRemoverComVinculos')
          .replace('{nome}', familiaRemovida.nome)
          .replace('{vinculos}', familiaRemovida.vinculos.toString());
        this.exibirErro(mensagem, this.translate.instant('parametros.familia.avisoVinculosAtivos'));
        return;
      }

      // Mostrar modal de confirmação
      this.familiaParaExcluir = familiaRemovida;
      this.displayConfirmarExclusao = true;
    }
  }

  confirmarExclusao() {
    if (!this.familiaParaExcluir) return;

    // Chamada para o backend para remover a família
    this.serviceFamilia.removerFamilia(this.familiaParaExcluir.id)
      .then((response: any) => {
        this.exibirSucesso(
          this.translate.instant('parametros.familia.familiaRemovida'), 
          this.translate.instant('parametros.familia.sucesso')
        );
        this.hideDialogConfirmarExclusao();
        
        // Recarregar a lista de famílias após remover
        this.carregarFamilias();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.familia.erroRemoverFamilia'),
          this.translate.instant('parametros.familia.erro'),
          error
        );
      });
  }

  hideDialogConfirmarExclusao() {
    this.displayConfirmarExclusao = false;
    this.familiaParaExcluir = null;
  }

  verVinculos(familia: any) {
    this.familiaSelecionada = familia;
    
    // Inicializar com arrays vazios para garantir que o modal abra
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
    
    // Ativar loading
    this.carregandoVinculos = true;
    
    // Abrir o modal primeiro
    this.displayVinculos = true;
    
    // Depois carregar os dados
    this.carregarElementosVinculos(familia.id);
  }

  carregarElementosVinculos(familiaId: number) {
    // Chamada para o backend para buscar os vínculos da família
    this.serviceFamilia.getVinculosFamilia(familiaId)
      .then((response: any) => {
        
        // Verificar se a resposta tem a estrutura esperada
        let dadosVinculos = response;
        
        // Se a resposta estiver dentro de response.data, usar response.data
        if (response && response.data) {
          dadosVinculos = response.data;
        }
        
        // Se não há dados, inicializar com arrays vazios
        if (!dadosVinculos) {
          dadosVinculos = {
            disponiveis: [],
            vinculados: []
          };
        }
        
        this.processarVinculosFamilia(dadosVinculos);
        this.carregandoVinculos = false; // Desativar loading
      })
      .catch((error: any) => {
        console.error('Erro ao carregar vínculos:', error); // Debug
        this.carregandoVinculos = false; // Desativar loading mesmo em caso de erro
        this.tratarErro(
          this.translate.instant('parametros.familia.erroCarregarVinculos'),
          this.translate.instant('parametros.familia.erro'),
          error
        );
      });
  }

  private processarVinculosFamilia(dadosVinculos: any) {
    // Processar os dados de vínculos recebidos da API
    
    // Converter arrays de objetos para o formato interno
    this.elementosDisponiveis = (dadosVinculos.disponiveis || []).map((item: any, index: number) => ({
      id: `disp_${index}`,
      nome: item.produto,
      criadoPor: item.criadoPor,
      idDealer: item.idDealer,
      vinculado: false
    }));
    
    this.elementosVinculados = (dadosVinculos.vinculados || []).map((item: any, index: number) => ({
      id: `vinc_${index}`,
      nome: item.produto,
      criadoPor: item.criadoPor,
      idDealer: item.idDealer,
      vinculado: true
    }));

    // Inicializar listas filtradas
    this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }


  adicionarVinculo(elemento: any) {
    if (elemento.vinculado) return;

    // Remover da lista de disponíveis
    const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosDisponiveis.splice(index, 1);
    }

    // Adicionar à lista de vinculados
    elemento.vinculado = true;
    this.elementosVinculados.push(elemento);

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();

    this.alteracoesVinculos = true;
  }

  removerVinculo(elemento: any) {
    // Remover da lista de vinculados
    const index = this.elementosVinculados.findIndex(e => e.id === elemento.id);
    if (index > -1) {
      this.elementosVinculados.splice(index, 1);
    }

    // Adicionar à lista de disponíveis
    elemento.vinculado = false;
    this.elementosDisponiveis.push(elemento);

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();

    this.alteracoesVinculos = true;
  }

  // Métodos para pesquisa e ações em massa
  filtrarElementosDisponiveis() {
    if (!this.termoPesquisaDisponiveis || this.termoPesquisaDisponiveis.trim() === '') {
      this.elementosDisponiveisFiltrados = [...this.elementosDisponiveis];
    } else {
      const termo = this.termoPesquisaDisponiveis.toLowerCase().trim();
      this.elementosDisponiveisFiltrados = this.elementosDisponiveis.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  filtrarElementosVinculados() {
    if (!this.termoPesquisaVinculados || this.termoPesquisaVinculados.trim() === '') {
      this.elementosVinculadosFiltrados = [...this.elementosVinculados];
    } else {
      const termo = this.termoPesquisaVinculados.toLowerCase().trim();
      this.elementosVinculadosFiltrados = this.elementosVinculados.filter(elemento =>
        elemento.nome.toLowerCase().includes(termo) ||
        (elemento.criadoPor && elemento.criadoPor.toLowerCase().includes(termo))
      );
    }
  }

  limparPesquisaDisponiveis() {
    this.termoPesquisaDisponiveis = '';
    this.filtrarElementosDisponiveis();
  }

  limparPesquisaVinculados() {
    this.termoPesquisaVinculados = '';
    this.filtrarElementosVinculados();
  }

  vincularTodosFiltrados() {
    if (this.elementosDisponiveisFiltrados.length === 0) return;

    // Vincular todos os elementos filtrados
    const elementosParaVincular = [...this.elementosDisponiveisFiltrados];
    
    elementosParaVincular.forEach(elemento => {
      if (!elemento.vinculado) {
        // Remover da lista de disponíveis
        const index = this.elementosDisponiveis.findIndex(e => e.id === elemento.id);
        if (index > -1) {
          this.elementosDisponiveis.splice(index, 1);
        }

        // Adicionar à lista de vinculados
        elemento.vinculado = true;
        this.elementosVinculados.push(elemento);
      }
    });

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;
  }

  removerTodosVinculos() {
    if (this.elementosVinculados.length === 0) return;

    const totalRemovidos = this.elementosVinculados.length;

    // Remover todos os vínculos
    this.elementosVinculados.forEach(elemento => {
      elemento.vinculado = false;
      this.elementosDisponiveis.push(elemento);
    });

    this.elementosVinculados = [];

    // Atualizar listas filtradas
    this.filtrarElementosDisponiveis();
    this.filtrarElementosVinculados();
    this.alteracoesVinculos = true;


  }

  salvarVinculos() {
    if (!this.alteracoesVinculos) return;

    // Chamada para a API para salvar os vínculos
    this.serviceFamilia.salvarVinculosFamilia(this.familiaSelecionada.id, this.elementosVinculados)
      .then((response: any) => {
        // Atualizar o contador local
        this.familiaSelecionada.vinculos = this.elementosVinculados.length;
        
        // Atualizar também na lista principal de famílias
        const familiaIndex = this.familias.findIndex(f => f.id === this.familiaSelecionada.id);
        if (familiaIndex > -1) {
          this.familias[familiaIndex].vinculos = this.elementosVinculados.length;
        }
        
        this.exibirSucesso(
          this.translate.instant('parametros.familia.vinculosSalvos'), 
          this.translate.instant('parametros.familia.sucesso')
        );

        this.alteracoesVinculos = false;
        this.hideDialogVinculos();
      })
      .catch((error: any) => {
        this.tratarErro(
          this.translate.instant('parametros.familia.erroSalvarVinculos'),
          this.translate.instant('parametros.familia.erro'),
          error
        );
      });
  }

  hideDialogVinculos() {
    this.displayVinculos = false;
    this.carregandoVinculos = false;
    this.familiaSelecionada = null;
    this.elementosDisponiveis = [];
    this.elementosVinculados = [];
    this.elementosDisponiveisFiltrados = [];
    this.elementosVinculadosFiltrados = [];
    this.termoPesquisaDisponiveis = '';
    this.termoPesquisaVinculados = '';
    this.alteracoesVinculos = false;
  }

  // TrackBy function para otimizar performance
  trackByElemento(index: number, elemento: any): number {
    return elemento.id;
  }

  exibirSucesso(mensagem: string, titulo: string) {
    this.toastr.success(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  exibirErro(mensagem: string, titulo: string) {
    this.toastr.error(mensagem, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;
    console.error(error);
    let msg: string;
    try {
      if (error.status === 401) {
        this.router.navigateByUrl('logout');
      }
      msg = mensagem + '\n' + error.erro;
    } catch (Exception) {
      msg = mensagem;
    }
    this.toastr.error(msg, titulo, {
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true
    });
  }
}
